import Class from './c-view';
import './c-view@.vue';

export default Class;